<template>
  <div class="q-mt-md">
    <div class="row q-col-gutter-md items-center q-mb-sm">
      <div class="col-12 col-md">
        <div class="text-h6">{{ title }}</div>
      </div>
      <div class="col-12 col-md-4">
        <q-input
          dense
          outlined
          clearable
          v-model="search"
          icon="search"
          label="Поиск по контрагенту, ИНН или документу"
        >
          <template v-slot:prepend>
            <q-icon name="search" />
          </template>
        </q-input>
      </div>
    </div>

    <div v-accessible-scroll-region="`${title}: таблица`" class="book-table__scroll">
      <q-table
        v-accessible-scroll-region="{ label: `${title}: таблица`, selector: '.q-table__middle' }"
        flat
        dense
        bordered
        row-key="id"
        :rows="filteredRows"
        :columns="columns"
        :pagination="pagination"
        no-data-label="За выбранный период документы не найдены"
      >
        <template v-slot:body-cell-line_no="props">
          <q-td :props="props">{{ props.row.line_no || props.rowIndex + 1 }}</q-td>
        </template>

        <template v-slot:body-cell-inn_kpp="props">
          <q-td :props="props">
            {{ props.row.counterparty_inn || '—' }}<span v-if="props.row.counterparty_kpp"> / {{ props.row.counterparty_kpp }}</span>
          </q-td>
        </template>

        <template v-slot:body-cell-operation_code="props">
          <q-td :props="props">{{ props.row.operation_code || '01' }}</q-td>
        </template>

        <template v-slot:body-cell-vat_rate="props">
          <q-td :props="props">{{ props.row.vat_rate || '—' }}</q-td>
        </template>

        <template v-slot:body-cell-currency="props">
          <q-td :props="props">{{ props.row.currency || 'RUB' }}</q-td>
        </template>

        <template v-slot:body-cell-amount="props">
          <q-td :props="props">{{ formatMoney(props.value) }}</q-td>
        </template>

        <template v-slot:body-cell-vat_amount="props">
          <q-td :props="props">{{ formatMoney(props.value) }}</q-td>
        </template>

        <template v-slot:body-cell-source="props">
          <q-td :props="props">
            <q-btn
              v-if="documentRoute(props.row)"
              flat
              dense
              color="primary"
              icon="open_in_new"
              label="Открыть"
              @click="$router.push(documentRoute(props.row))"
            />
            <span v-else>—</span>
          </q-td>
        </template>
      </q-table>
    </div>

    <div v-if="hasTotals" class="row q-col-gutter-md q-mt-sm text-caption text-grey-8">
      <div class="col-auto">
        Итого сумма: <strong>{{ formatMoney(totals.amount ?? 0) }}</strong>
      </div>
      <div class="col-auto">
        Итого НДС: <strong>{{ formatMoney(totals.vat ?? 0) }}</strong>
      </div>
    </div>
  </div>
</template>

<script>
import { formatMoney } from '../utils/reportFormatters'

export default {
  name: 'DocumentBookTable',
  props: {
    title: {
      type: String,
      required: true
    },
    rows: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      required: true
    },
    totals: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      search: '',
      pagination: {
        sortBy: 'date',
        descending: true,
        page: 1,
        rowsPerPage: 50
      }
    }
  },
  computed: {
    filteredRows() {
      const needle = String(this.search || '').trim().toLowerCase()
      if (!needle) {
        return this.rows
      }
      return this.rows.filter((row) => {
        const values = [
          row.name,
            row.counterparty_name,
            row.contr_name,
            row.counterparty_inn,
            row.counterparty_kpp,
            row.inn,
            row.kpp,
            row.invoice_number,
            row.linked_factura_number
        ]
        return values.some((value) => String(value || '').toLowerCase().indexOf(needle) !== -1)
      })
    },
    hasTotals() {
      return this.totals && (this.totals.amount !== undefined || this.totals.vat !== undefined)
    }
  },
  methods: {
    formatMoney,
    documentRoute(row) {
      const id = row && (row.document_id || row.id)
      if (!id) {
        return null
      }
      if (row.document_type === 'upd') {
        return { name: 'document_info_upd', params: { id, history_id: 'last' } }
      }
      if (row.document_type === 'payment') {
        return { name: 'document_info_payment', params: { id, history_id: 'last' } }
      }
      if (row.document_type === 'factura_avance') {
        return { name: 'document_info_factura_avance', params: { id, history_id: 'last' } }
      }
      return { name: 'document_info_upd', params: { id, history_id: 'last' } }
    }
  }
}
</script>

<style scoped>
.book-table__scroll {
  max-width: 100%;
  overflow-x: auto;
}

.book-table__scroll :deep(.q-table) {
  min-width: 1180px;
}
</style>
